export default __webpack_public_path__ + "images/nej/hero-dashboard.jpg";